<template>
  <div id="app">
    <Select />
    <Results />
  </div>
</template>

<script>
import Select from "./components/Select.vue";
import Results from "./components/Results.vue";
import { mapActions } from "vuex";

export default {
  name: "App",
  components: {
    Select,
    Results
  },
  methods: {
    ...mapActions({
      fetchData: "fetchData",
      setIsMobile: "setIsMobile"
    }),
    handleResize() {
      let isMobile = document.documentElement.clientWidth < 768 ? true : false;
      this.setIsMobile(isMobile);
    }
  },
  mounted() {
    this.fetchData();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>

<style lang="scss">
@import "./assets/scss/typography";
@import "./assets/scss/colours";
@import "./assets/scss/vue-select";
#app {
  max-width: 800px;
  margin: 0 auto;
}
body {
  margin: 0px;
}
</style>
